import { render, staticRenderFns } from "./inputDate.vue?vue&type=template&id=1dea8c26"
import script from "./inputDate.vue?vue&type=script&lang=ts"
export * from "./inputDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports